import UpdateApiKeysStore from '../stores/update-api-key-store';
import { ApiKey } from '../types/api-key-types';

export const closeDeleteApiKeyModal = (): void => {
  clearErrorMessage();
  setModalVisibilityDeleteApiKey(false);
};

export const openDeleteApiKeyModal = (): void => {
  setModalVisibilityDeleteApiKey(true);
};

const setModalVisibilityDeleteApiKey = (payload: boolean): void => {
  UpdateApiKeysStore.isModalVisibleDeleteApiKey = payload;
};

export const setLoadingDeleteApiKey = (isLoading: boolean) => {
  UpdateApiKeysStore.isLoadingDeleteApiKey = isLoading;
};

export const closeSetApiKeyStatusModal = (): void => {
  clearErrorMessage();
  setModalVisibilitySetApiKeyStatus(false);
};

export const openSetApiKeyStatusModal = (): void => {
  setModalVisibilitySetApiKeyStatus(true);
};

const setModalVisibilitySetApiKeyStatus = (payload: boolean): void => {
  UpdateApiKeysStore.isModalVisibleSetApiKeyStatus = payload;
};

export const setLoadingSetApiKeyStatus = (isLoading: boolean) => {
  UpdateApiKeysStore.isLoadingSetApiKeyStatus = isLoading;
};

export const closeSetApiKeyExpirationModal = (): void => {
  clearErrorMessage();
  setModalVisibilitySetApiKeyExpiration(false);
};

export const openSetApiKeyExpirationModal = (): void => {
  setModalVisibilitySetApiKeyExpiration(true);
};

const setModalVisibilitySetApiKeyExpiration = (payload: boolean): void => {
  UpdateApiKeysStore.isModalVisibleSetApiKeyExpiration = payload;
};

export const setLoadingSetApiKeyExpiration = (isLoading: boolean) => {
  UpdateApiKeysStore.isLoadingSetApiKeyExpiration = isLoading;
};

export const clearErrorMessage = () => {
  UpdateApiKeysStore.errorMessage = null;
};

export const setErrorMessage = (msg: string) => {
  UpdateApiKeysStore.errorMessage = msg;
};

export const setSelectedApiKey = (apiKey: ApiKey) => {
  UpdateApiKeysStore.selectedApiKey = apiKey;
};

export const clearSelectedApiKey = () => {
  UpdateApiKeysStore.selectedApiKey = null;
};
